import PropTypes from 'prop-types';
import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/pro-light-svg-icons/faCheck";
import {faExternalLink} from "@fortawesome/pro-light-svg-icons/faExternalLink";

export const THEME_SINGLE_CENTER = "THEME_SINGLE_CENTER"
export const THEME_FLOATING_DESCRIPTION = "THEME_FLOATING_DESCRIPTION"
export const THEME_BLOCK_DESCRIPTION = "THEME_BLOCK_DESCRIPTION"
export const THEME_SEPARATOR = "THEME_SEPARATOR"

function ToggleButton(props) {

    let alignClass = ""

    switch (props.align) {
        case "left":
            alignClass = " toggle-button--left"
            break
        case "right":
            alignClass = " toggle-button--right"
            break
        default:
            alignClass = ""
            break
    }

    let themeClass = ""

    if (props.theme === THEME_FLOATING_DESCRIPTION && props.description) {
        themeClass = " toggle-button--theme-floating"
    } else if (props.theme === THEME_BLOCK_DESCRIPTION) {
        themeClass = " toggle-button--theme-block"
    }

    if (props.disabled) {
        themeClass += " disabled"
    }

    if (props.style) {
        themeClass += " toggle-button--style-" + props.style;
    }

    return (
        <button
            type="button"
            data-tip={props.disabled ? props.disabledTooltip : null}
            data-for={"global"}
            onClick={(e) => {
                if (!props.disabled) {
                    props.onClick(e);
                }
            }
            } className={props.className + alignClass + themeClass + " toggle-button"}>
            <span className={"toggle-button__title"}>{props.icon ? <FontAwesomeIcon icon={props.icon}/> : null}{props.buttonLabel}</span>
            {props.description ? <p>{props.description}</p> : null}
            {props.hint !== "" ? <div className="toggle-button__hint">{props.hint}</div> : null}
            {props.selected ? <div className={"toggle-button__check"}>
                <FontAwesomeIcon icon={faCheck}/>
            </div> : null}
            {props.isExternalLink ? <FontAwesomeIcon className="toggle-button__external" icon={faExternalLink}/> : null}
        </button>
    );

}

ToggleButton.propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    align: PropTypes.string,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    className: PropTypes.string,
    hint: PropTypes.string,
    description: PropTypes.string,
    theme: PropTypes.string,
    disabled: PropTypes.bool,
    disabledTooltip: PropTypes.string
};

ToggleButton.defaultProps = {
    hint: "",
    theme: THEME_SINGLE_CENTER
};

export default ToggleButton



/** WEBPACK FOOTER **
 ** ./src/components/ToggleButton.js
 **/